module.exports = __webpack_public_path__ + "img/3445-virginia-avenue-st-louis_rb.1b5463d9.jpg";